import SavingsIcon from "@mui/icons-material/Savings";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GavelIcon from "@mui/icons-material/Gavel";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import SecurityIcon from "@mui/icons-material/Security";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import HandshakeIcon from "@mui/icons-material/Handshake";
import PaymentIcon from "@mui/icons-material/Payment";
import BuildIcon from "@mui/icons-material/Build";

// Default Cities Data
export const defaultCities = [
  { name: "Karachi", propertyCount: 0, image: "https://images.unsplash.com/photo-1567157577867-05ccb1388e66?w=400" },
  { name: "Lahore", propertyCount: 0, image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=400" },
  { name: "Islamabad", propertyCount: 0, image: "https://images.unsplash.com/photo-1608020932658-d0e19a69580b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=400" },
  { name: "Rawalpindi", propertyCount: 0, image: "https://images.unsplash.com/photo-1582125276040-84f8be6e205c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=400" },
  { name: "Faisalabad", propertyCount: 0, image: "https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=400" },
  { name: "Multan", propertyCount: 0, image: "https://images.unsplash.com/photo-1599420186946-7b6fb4e297f0?w=400" },
];

export const cityImages = {
  Karachi: "https://images.unsplash.com/photo-1567157577867-05ccb1388e66?w=400",
  Lahore: "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=400",
  Islamabad: "https://images.unsplash.com/photo-1608020932658-d0e19a69580b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=400",
  Rawalpindi: "https://images.unsplash.com/photo-1582125276040-84f8be6e205c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=400",
  Faisalabad: "https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=400",
  Multan: "https://images.unsplash.com/photo-1599420186946-7b6fb4e297f0?w=400",
};//

// Why Choose OTS - For Property Owners
export const ownerBenefits = [
  { icon: <SavingsIcon />, title: "Zero Commission", desc: "List your property completely free - no hidden charges, no commission fees" },
  { icon: <VerifiedUserIcon />, title: "Verified Tenants", desc: "Connect with pre-screened, verified tenants looking for quality homes" },
  { icon: <GavelIcon />, title: "Legal Protection", desc: "Digital rental agreements that protect your rights and property" },
  { icon: <ReceiptLongIcon />, title: "Bill Management", desc: "Track and manage all utility bills with complete transparency" },
];

// Why Choose OTS - For Tenants
export const tenantBenefits = [
  { icon: <HomeWorkIcon />, title: "Verified Properties", desc: "Browse genuine listings with verified property details and photos" },
  { icon: <SecurityIcon />, title: "Secure Payments", desc: "Safe and secure online transactions through trusted payment gateway" },
  { icon: <GavelIcon />, title: "Digital Agreement", desc: "Get legally binding rental agreements for your protection" },
  { icon: <SupportAgentIcon />, title: "Dedicated Support", desc: "Our support team is here to help you throughout your rental journey" },
];

// How it Works - Property Owners
export const ownerSteps = [
  {
    icon: <PersonAddIcon sx={{ fontSize: 40 }} />,
    title: "Create Your Account",
    desc: "Sign up for free and complete your profile verification in minutes"
  },
  {
    icon: <HomeWorkIcon sx={{ fontSize: 40 }} />,
    title: "List Your Property",
    desc: "Add property details, upload photos, set rent and terms"
  },
  {
    icon: <SearchOutlinedIcon sx={{ fontSize: 40 }} />,
    title: "Receive Applications",
    desc: "Get interest requests from verified tenants directly"
  },
  {
    icon: <HandshakeIcon sx={{ fontSize: 40 }} />,
    title: "Finalize & Manage",
    desc: "Create digital agreement and manage your property seamlessly"
  },
];

// How it Works - Tenants
export const tenantSteps = [
  {
    icon: <SearchOutlinedIcon sx={{ fontSize: 40 }} />,
    title: "Search Properties",
    desc: "Browse properties by location, budget, and preferences"
  },
  {
    icon: <HomeWorkIcon sx={{ fontSize: 40 }} />,
    title: "Express Interest",
    desc: "Send interest request to property owners you like"
  },
  {
    icon: <PaymentIcon sx={{ fontSize: 40 }} />,
    title: "Secure Payment",
    desc: "Pay advance securely through our trusted payment system"
  },
  {
    icon: <ReceiptLongIcon sx={{ fontSize: 40 }} />,
    title: "Move In",
    desc: "Receive your digital agreement and move into your new home"
  },
];

// Platform Features
export const platformFeatures = [
  {
    icon: <SavingsIcon sx={{ fontSize: 50 }} />,
    title: "Free Property Listing",
    desc: "Property owners can list unlimited properties without any listing fees or commission charges",
    color: "#11998e",
  },
  {
    icon: <GavelIcon sx={{ fontSize: 50 }} />,
    title: "Digital Agreements",
    desc: "Legally valid rental agreements with digital signatures from both parties",
    color: "#667eea",
  },
  {
    icon: <ReceiptLongIcon sx={{ fontSize: 50 }} />,
    title: "Bill Management",
    desc: "Complete utility bill tracking for electricity, gas, water, and maintenance",
    color: "#f093fb",
  },
  {
    icon: <BuildIcon sx={{ fontSize: 50 }} />,
    title: "Maintenance Tracking",
    desc: "Streamlined system for tenants to report and track maintenance requests",
    color: "#f5576c",
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 50 }} />,
    title: "Secure Transactions",
    desc: "All payments processed through SafePay - Pakistan's trusted payment gateway",
    color: "#4facfe",
  },
  {
    icon: <VerifiedUserIcon sx={{ fontSize: 50 }} />,
    title: "Verified Users",
    desc: "All users go through verification process ensuring safe and trusted community",
    color: "#43e97b",
  },
];

// Testimonials
export const testimonials = [
  {
    name: "Ahmed Raza",
    role: "Property Owner",
    city: "Karachi",
    text: "OTS has completely transformed how I manage my rental properties. The digital agreements and bill tracking features save me hours every month. Highly recommended for all property owners!",
    rating: 5,
    avatar: "A",
  },
  {
    name: "Sarah Khan",
    role: "Tenant",
    city: "Lahore",
    text: "Finding a good rental used to be so stressful. With OTS, I found my perfect apartment within days. The transparent process and secure payment gave me complete peace of mind.",
    rating: 5,
    avatar: "S",
  },
  {
    name: "Usman Ali",
    role: "Property Owner",
    city: "Islamabad",
    text: "Managing 5 properties was a nightmare before OTS. Now everything is organized - tenant communication, bills, maintenance requests - all in one place. Excellent platform!",
    rating: 5,
    avatar: "U",
  },
];

// Value Proposition Points
export const valuePoints = [
  "No broker fees or hidden charges for property owners",
  "Minimal platform fee (500Rs per property) for Owners",
  "Legally binding digital rental agreements",
  "Complete transparency in all transactions",
  "Dedicated customer support throughout your journey"
];
